import LookupAliases from '../components/LookupAliases';
const columns = [
    { accessorKey: 'stateName', header: 'State', meta: { sortBy: 'StateName', relatedFields: ['stateId', 'enerexIdentifier', 'enerexZoneId', 'enerexStateIdentifier'] }, cell: ({ getValue }) => getValue() ?? '—' },
    { accessorKey: 'code', header: 'Code', meta: { sortBy: 'Code' }, cell: ({ getValue }) => getValue() ?? '—' },
    { accessorKey: 'aliases', header: 'Aliases', meta: { sortBy: 'Aliases' }, cell: ({ getValue, row }) => <LookupAliases value={getValue()} recordName={row.original.code || 'Load Profile'} /> },
];

export default columns;
